import React, { useMemo } from 'react'
import RoomBreakdownDetails from './RoomBreakdownDetails'
import useOfferMetaData from '../../../../hooks/Offers/useOfferMetaData'
import { isBedbankSearchRoom, isLEOffer, isReservationSearchRoom } from 'lib/offer/offerTypes'
import useBedbankRoomBreakdown from '../../../../hooks/useBedbankRoomBreakdown'
import { getPackageRoomBreakdown } from 'lib/search/searchUtils'
import { pluralizeToString } from 'lib/string/pluralize'
import { excludeNullOrUndefined } from 'checkout/utils'
interface Props {
  offer: App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary
  filters?: App.OfferListFilters
}

function SearchTileRoomBreakdown({
  offer,
  filters,
}: Props) {
  const metaData = useOfferMetaData(offer.id, filters)

  const recommendedForText = useMemo(() => {
    const numberOfAdults = filters?.rooms?.reduce((sum, room) => sum + room.adults, 0) ?? 0
    const numberOfChildren = filters?.rooms?.reduce((sum, room) => sum + (room.teenagers ?? 0) + (room.children ?? 0) + (room.infants ?? 0), 0) ?? 0
    return `Recommended for ${numberOfAdults} adults${numberOfChildren > 0 ? `, ${pluralizeToString('child', numberOfChildren)}` : ''}`
  }, [filters?.rooms])

  const packageIds = useMemo(() =>
    metaData?.rooms.filter(isReservationSearchRoom).map(r => r.packageId) ?? [],
  [metaData?.rooms])

  const leRoomsList = useMemo(() =>
    getPackageRoomBreakdown(packageIds, isLEOffer(offer) ? offer.packages : []),
  [packageIds, offer])

  const bedbankRooms = useMemo(() =>
    metaData?.rooms
      .filter(isBedbankSearchRoom)
      .map(r => (r.rateId ? { rateId: r.rateId, propertyId: r.propertyId } : undefined))
      .filter(excludeNullOrUndefined) ?? [],
  [metaData?.rooms])

  const bedbankRoomsList = useBedbankRoomBreakdown(bedbankRooms, filters)

  const allRooms = useMemo(() =>
    [...leRoomsList, ...bedbankRoomsList],
  [leRoomsList, bedbankRoomsList])

  if (allRooms.length === 0) return null

  return (
    <RoomBreakdownDetails
      recommendedForText={recommendedForText}
      rooms={allRooms}
    />
  )
}

export default SearchTileRoomBreakdown
